import { Divider, Modal } from "antd";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& p": {
      margin: "0",
    },
    "& h4": {
      margin: "0",
    },
  },
  tabs: {
    "& .ant-tabs-nav": {
      background: "#FDFBE8",
      "& .ant-tabs-tab-active": {
        background: "#fff",
      },
    },
    "& .ant-tabs-tab": {
      padding: "16px 36px",
      margin: "0",
    },
  },
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.8px solid #D4D4D4",
  },
  contentListStyle: {
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "body::-webkit-scrollbar-thumb": {
      borderRadius: "20px",
    },
  },
  customCol6: {
    display: "flex",
    justifyContent: "center",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
}));

const itemTypes = {
  starter: "STARTERS",
  dessert: "DESSERTS",
};

const ViewItemModal = ({ openModal, setOpenModal, selectedRow = {} }) => {
  const classes = useStyles();
  const handleClose = () => {
    setOpenModal(false);
  };
  console.log("selectedRow", selectedRow);
  return (
    <Modal
      open={openModal}
      centered
      footer={false}
      onCancel={handleClose}
      className={classes.modalStyle}
    >
      <h3
        style={{
          color: "#EF4667",
        }}
      >
        Items
      </h3>
      <Divider
        style={{
          margin: "0.5rem 0",
          border: "0.5px solid #909090",
        }}
      />
      <div
        style={{
          padding: "8px 30px 18px",
          height: "500px",
          overflowY: "auto",
        }}
        className={classes.contentListStyle}
      >
        {selectedRow?.items?.map((order, index, arr) => {
          return (
            <React.Fragment key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <p
                  style={{
                    margin: "0",
                  }}
                >
                  {order.productName}
                </p>
                <p
                  style={{
                    margin: "0",
                  }}
                >
                  {order.count}
                </p>
              </div>
              {arr?.length - 1 !== index && (
                <Divider className={classes.dividerStyle} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </Modal>
  );
};

export default ViewItemModal;
